import { CiLock, CiUnlock } from "react-icons/ci";

export const SYSTEM_ACCESS = ["amnIbEVWkPUysFt3Kjmr", "rkXsYv8H41SHOM9ZAoky"];

export const USER_GROUPS = [
  {
    name: "Administrator",
    value: "Administrator",
    permissions: ["p0", "c1", "c2", "t1", "n1"],
  },
  {
    name: "Quản trị viên",
    value: "Operator",
    permissions: ["c1"],
  },
];

export const FULL_PERMISSION = ["p0", "c1", "c2", "t1", "n1"];

export const PERMISSION = {
  OPERATOR: "p0",
  CONCEPT: "c1",
  APPROVE: "c2",
  THREE: "t1",
  NEWS: "n1",
};

export const SUB_PERMISSION = {};

export const TIMESTAMP = "DD/MM/YYYY HH:mm:ss";

export const CATEGORIES_SOURCE = [
  {
    label: "VDI GROUP",
    value: "vdigroup",
  },
];

const size = 20;
const color = "black";
export const STATUS_DOCUMENT = [
  {
    value: true,
    label: "Đang khoá",
    icon: <CiLock color={color} size={size} />,
  },
  {
    value: false,
    label: "Có thể tải",
    icon: <CiUnlock color={color} size={size} />,
  },
];

/// ====== COLORS SPEAKER ======== //
export const COLORS_SPEAKER = [
  "#E1EDF5",
  "#DBEAE1",
  "#edc2cf",
  "#edecc2",
  "#cbc2ed",
];

/// ====== JOB STATUS ======== //

export const JOB_STATUS = [
  {
    value: "extracting",
    label: "Xác Nhận và chờ báo giá",
    color: "blue",
  },
  {
    value: "waiting for deposit",
    label: "Báo giá",
    color: "orange",
  },
  {
    value: "transcripting",
    label: "AI đang chuyển Âm",
    color: "red",
  },
  {
    value: "supporting",
    label: "AI đang chỉnh sửa Wording",
    color: "purple",
  },
  {
    value: "approval",
    label: "AI đánh giá chất lượng",
    color: "orange",
  },

  {
    value: "ready for download",
    label: "Sẵn sàng để tải",
    color: "green",
  },
  {
    value: "ready for forwarding",
    label: "Sẵn sàng để bàn giao",
    color: "purple",
  },
  {
    value: "failed",
    label: "File lỗi",
    color: "red",
  },
];
